import { Asterisk } from "lucide-react";

const ITEMS = [
  "Vector Artwork Conversion",
  "Real-Time Order Tracking",
  "Virtual Samples & Proofs",
  "Vendor Follow-Ups",
  "US · Canada · UK · Australia",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee-container"
    className="relative overflow-hidden border-y border-slate-200 bg-white py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-slate-500">
                {item}
              </span>
              <Asterisk className="mx-8 h-4 w-4 text-[#2E3192]/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
